import { render, staticRenderFns } from "./TransportPyme.vue?vue&type=template&id=15a4a8b4&"
import script from "./TransportPyme.vue?vue&type=script&lang=js&"
export * from "./TransportPyme.vue?vue&type=script&lang=js&"
import style0 from "./TransportPyme.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports